export default "__VITE_ASSET__aa4f7266__"